import { render } from "./GoalPage.vue?vue&type=template&id=04ce635c&scoped=true"
import script from "./GoalPage.vue?vue&type=script&lang=js"
export * from "./GoalPage.vue?vue&type=script&lang=js"

import "./GoalPage.vue?vue&type=style&index=0&id=04ce635c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ce635c"]])

export default __exports__